import { useNewCode } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { RecaptchaProvider } from '@calendly/recaptcha';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Grid, GridItem } from '@calendly/ui/components/grid';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import { HeadlineText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Settings from 'core/settings';
import { statisticsSelector } from 'features/organization_statistics';
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants';
import { useTrack } from 'hooks/analytics_events/useTrack';
import { modalAboveOverlayStackingCss } from 'shared/modal_stacking';
import { isMfaOpenSelector, isSubmittingSelector } from '../selectors';
import { closeAddUserModal } from '../slice';
import { AvailableSeatsMessage } from './components/available_seats_message';
import { InviteForm } from './components/invite_form';
import { NoSeatsBanner } from './components/no_seats_banner';
import { ValuePropBanner } from './components/value_prop_banner';
const styledSheetIsAdminOnboardingExperimentCss = "s1ypdlbg";
const styledSheetIsPhoneCss = "s1g1nngd";
const styledSheetCss = "ssb9wcp";
const StyledSheet = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  const isAdminOnboardingExperiment = useNewCode('activation_q3', false)?.enabled;
  return <Sheet ref={ref} {...props} className={classNames(styledSheetCss, {
    [styledSheetIsAdminOnboardingExperimentCss]: isAdminOnboardingExperiment,
    [styledSheetIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledBareButtonCss = "s109k737";
const StyledBareButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledBareButtonCss, props.className)} />);
export const AddUsersModal = ({
  isOpen,
  onClose = () => {},
  onSuccess = () => {}
}) => {
  const track = useTrack();
  const {
    available_seats: availableSeats,
    isLoading
  } = useSelector(statisticsSelector) || 0;
  const isAdminOnboardingExperiment = useNewCode('activation_q3', false)?.enabled;
  const dispatch = useDispatch();
  const {
    pathname
  } = useLocation();
  const recaptchaSettings = Settings.recaptcha || {};
  const isMfaOpen = useSelector(isMfaOpenSelector);
  const isSubmitting = useSelector(isSubmittingSelector);
  if (!isOpen) return null;
  const onCloseModal = () => {
    if (isSubmitting) return;
    onClose();
    track({
      name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
      properties: {
        modal_name: 'invite_user_email_flow',
        action: 'closing',
        path: pathname
      }
    });
    dispatch(closeAddUserModal());
  };
  return <RecaptchaProvider siteKey={recaptchaSettings.site_key} isActive={!!recaptchaSettings.activated} siteKeyV2={recaptchaSettings.site_key_v2} isActiveV2={!!recaptchaSettings.activated_v2}>
      <Modal data-testid="add-users-modal" isOpen={isOpen} onClose={onCloseModal} className={isMfaOpen ? '' : modalAboveOverlayStackingCss}>
        <StyledSheet>
          <Grid>
            <GridItem size={11}>
              <HeadlineText level={1} size="medium">
                {isAdminOnboardingExperiment ? I18n.t('publisher.add_users_modal.experiment_heading') : I18n.t('publisher.add_users_modal.heading')}
              </HeadlineText>
            </GridItem>
            <GridItem size={1}>
              <StyledBareButton aria-label="Close" disabled={isSubmitting} id="invite-user-modal-close-button" onClick={onCloseModal}>
                <CloseIcon size="large" />
              </StyledBareButton>
            </GridItem>
          </Grid>
          {!isAdminOnboardingExperiment && !isLoading && availableSeats === 0 && <NoSeatsBanner />}
          <AvailableSeatsMessage availableSeats={availableSeats} />
          {isAdminOnboardingExperiment && <ValuePropBanner />}
          <InviteForm availableSeats={availableSeats} isModalOpen={isOpen} onClose={onCloseModal} inlineRoleSelect viaModal onSuccess={onSuccess} />
        </StyledSheet>
      </Modal>
    </RecaptchaProvider>;
};

require("./add_users_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./add_users_modal.js");